// 后端线上
export const HOST = 'https://pc-store.lenovomm.cn';
// 后端测试
// export const HOST = 'https://pc-store-test.lenovomm.cn';
// 后端开发
// export const HOST = 'https://pc-store-dev.lenovomm.cn';

export const CONTEXT = '/embedded_v7_4';
export const STORE_3G_HOST = 'https://3g.lenovomm.com';
export const STORE_3G_CHANNEL = '60028';

// 订单中心测试
// export const SHOP_ORDER_LIST_65 = 'https://pc-store-front.mbgtest.lenovomm.com/orderList';
export const SHOP_ORDER_LIST_65 = 'https://cloud-rest.lenovomm.com/front-store/orderList';

export const APP_VERSION = '7.4.0.0922';
export const APP_VERSION_CODE = '74000';

export const APP_VERSION_D = '7.4.30.0922';
export const APP_VERSION_CODE_D = '74300';

// 注册token
export const REGISTER_URL = `${HOST}/appbase/token/register`;
// 搜索结果
export const SEARCH_URL_52 = `${HOST}/appstorecontents/search/v1.0/search_apps`;
// 搜索
export const SEARCH_URL = `${HOST}/appstorecontents/search/search_apps`;
// 搜索联想词
export const LENOVO_WORDS_URL = `${HOST}/appstorecontents/search/associative_word`;
// 热词搜索
export const HOT_SEARCH_URL = `${HOST}/appstorecontents/search/hot_search_list`;
// 搜索结果安装推荐
export const SEARCH_RECOMMEND_URL = `${HOST}/appstorecontents/search/recommend`;
// 欢迎页弹窗
export const WELCOME_POPUP_URL = `${HOST}/appstorecontents/welcome/contents`;
// 欢迎页用户选择弹窗状态
export const WELCOME_POPUP_STATUS_URL = `${HOST}/appstorecontents/welcome/update_show_strategy`;
// 顶部banner与每日一荐
export const BANNER_TOPCONTENT_URL = `${HOST}/appstorecontents/banner/top_contents`;
//
export const TOP_BANNER_URL = `${HOST}/appstorecontents/banner/top_banners`;
// 猜你喜欢软件列表
export const GUESS_LIKES_URL = `${HOST}/appstorecontents/guess/likes`;
// 首页精品推荐
export const RECOMMENDS_SOFT_URL = `${HOST}/appstorecontents/recommends/soft`;
// 首页其他分组推荐
export const RECOMMENDS_GROUP_SOFT_URL = `${HOST}/appstorecontents/recommends/group_soft`;
// 本周最热
export const RECOMMENDS_WEEK_HOTS_URL = `${HOST}/appstorecontents/recommends/week_hots`;
// 单个排行榜单
export const RANK_RANK_APPS = `${HOST}/appstorecontents/rank/rank_apps`;
// 排行页展示的多个排行
export const RANK_RANKS = `${HOST}/appstorecontents/rank/ranks`;

// 分类列表
export const CLASSES_LIST = `${HOST}/appstorecontents/class/classes`;
// 获取分类下软件列表
export const CLASS_APPS = `${HOST}/appstorecontents/class/class_apps`;

// 获取应用详细信息
export const APP_DETAILS = `${HOST}/appstorecontents/app/details`;
// 获取应用相关推荐
export const APP_RECOMMEND_URL = `${HOST}/appstorecontents/app/recommend`;

// 提交需要检测的软件信息, 返回可升级的软件详情列表
export const UPGRADE_CHECK_URL = `${HOST}/appstorecontents/upgrade/check`;

// 心跳接口
export const CHECK_NETWORK_URL = `${HOST}/info`;

// 游戏页面接口
// 1、游戏分类软件列表
export const GAME_CLASS_APPS_LIST = `${HOST}/gamecontents/game/class_apps_list`;
// 2、分类列表
export const GAME_CLASSES = `${HOST}/gamecontents/game/classes`;
// 3、游戏页卡片类型内容接口
export const GAME_CONTENTS = `${HOST}/gamecontents/game/all_content`;
// 4、游戏榜单更多
export const GAME_RANK_MORE = `${HOST}/gamecontents/game/rank_more`;
// 5、游戏榜单页展示的多个榜单
export const GAME_RANKS = `${HOST}/gamecontents/game/ranks`;
// 6、游戏页下所有tab
export const GAME_TABS = `${HOST}/gamecontents/game/all_tab`;
// 游戏频道banners
export const GAME_BANNER = `${HOST}/appstorecontents/gamepage/game_banners`;
// 游戏推荐
export const GAME_RECOMMEND = `${HOST}/appstorecontents/gamepage/geme_recommend`;
// 全部游戏
export const GAME_ALL = `${HOST}/appstorecontents/gamepage/all_games`;

// 用户反馈地址
export const USER_FEEDBACK_URL = `https://club.lenovo.com.cn/forum-1586-1.html`;
// 商业合作
export const DEVELOPER_URL = `http://open.lenovo.com/developer/`;
// web 运行异常日志上报URL
export const REPORT_LOG_URL = `https://lecloud-pc.lenovo.com/facadeapi/web/v1/log`;

/* 5.2 安卓接口 */
// 安卓详情接口
export const ANDROID_APP_DETAILS = `${HOST}/phonecontent/app/details`;
// 安卓软件详情批量获取接口
export const ANDROID_APP_BATCH_DETAILS = `${HOST}/phonecontent/app/batch_details`;
// 安卓详情推荐接口
export const ANDROID_APP_DETAILS_RECOMMEND = `${HOST}/phonecontent/app/details/recommend`;
// 安卓推荐banner接口
export const ANDROID_BANNER_TOP_BANNER = `${HOST}/phonecontent/banner/top_banners`;
// 安卓精品推荐group
export const ANDROID_RECOMMEND_GROUP_SOFT = `${HOST}/phonecontent/recommends/group_soft`;
// 安卓精品推荐group单个list more
export const ANDROID_RECOMMEND_GROUP_SOFT_MORE = `${HOST}/phonecontent/recommends/group_soft_more`;
// 安卓精品推荐接口
export const ANDROID_RECOMMEND_SOFT = `${HOST}/phonecontent/recommends/soft`;

// 安卓分类获取接口
export const ANDROID_CLASS_CLASSES = `${HOST}/phonecontent/class/classes`;
// 安卓分类获取应用接口
export const ANDROID_CLASS_CLASS_APPS = `${HOST}/phonecontent/class/class_apps`;

/* 5.3新增接口 */
// banner(支持首页和游戏 banner)
export const BANNER_CONTENT_53 = `${HOST}/appstorecontents/banner/top_banner_content`;
// 精品推荐(支持首页和游戏 精品推荐)
export const RECOMMEND_CONTENT_53 = `${HOST}/appstorecontents/recommends/recommend_content`;
// 运营配置专区(支持首页和游戏 group配置专区)
export const GROUNP_CONTENT_53 = `${HOST}/appstorecontents/groups/group_content`;
// 专题排行榜更多
export const RANK_ZT_RANK_APPS_53 = `${HOST}/appstorecontents/rank/zt_rank_apps`;
// 首页流行榜
export const RANK_MIX_RANK_53 = `${HOST}/appstorecontents/rank/mix_rank`;

// 详情获取评论list
export const DETAIL_GET_COMMENT_LIST_53 = `${HOST}/comment/api/commentlist`;
// 详情获取评分统计
export const DETAIL_GET_GRADE_53 = `${HOST}/comment/api/grade`;
// 详情评论
export const DETAIL_ADD_COMMENT_53 = `${HOST}/comment/api/addComment`;
// 详情获取评分统计
export const DETAIL_ADD_ZAN_53 = `${HOST}/comment/api/zan`;

// 获取支持静默安装的应用
// export const SILENT_INSTALL_SOFT_53 = `${HOST}/upgrade/install/softInstallInfos`;
export const SILENT_INSTALL_SOFT_53 = `${HOST}/appstorecontents/system/parameter`;

/* 5.4新增接口 */
// 分类列表
export const CLASSES_LIST_54 = `${HOST}/appstorecontents/class/classes_list`;
// 获取分类下软件列表
export const CLASS_APPS_54 = `${HOST}/appstorecontents/class/class_apps_list`;

// 联想词接口
// export const ASSOCIATIVE_WORD_54 = `${HOST}/searchcontent/search/v1.0/associative_word`;
// 热词
export const HOTWORD_APP_LIST_54 = `${HOST}/searchcontent/search/hotword_app_list`;

/** 5.5新增接口 */
// 批量获取应用详情接口
export const GET_SOFT_INFOS_55 = `${HOST}/appstorecontents/app/mix_batch_details`;
// 获取专题详情接口
export const GET_SPECIAL_INFO_55 = `${HOST}/appstorecontents/zt/content`;
// 商城主页地址
export const SHOP_MAIN_PAGE_URL = 'https://store.zui.com?cid=sdlm';

/** 6.0新增接口 */
// 壁纸精品推荐列表
export const WP_RECOMMEND_IMG_60 = `${HOST}/wallpapercontent/wallpaper/recommends/img_stream`;
// 壁纸精品banner图
export const WP_TOP_BANNER_60 = `${HOST}/wallpapercontent/wallpaper/banner/top_banner_content`;
// 壁纸分类标签
export const WP_CATEGORY_LABELS_60 = `${HOST}/wallpapercontent/wallpaper/classify/tags`;
// 壁纸分类标签下拉滚动图片列表
export const WP_CATEGORY_TAGIMG_60 = `${HOST}/wallpapercontent/wallpaper/classify/tag_wallpapers`;
// 壁纸 我的喜欢
export const WP_MINE_COLLECTIMG_60 = `${HOST}/wallpapercontent/wallpaper/collect_list`;
// 壁纸 我的喜欢
export const WP_MINE_SETUP_60 = `${HOST}/wallpapercontent/wallpaper/settingUp_list`;
// 壁纸 收藏、设为壁纸、删除壁纸接口
export const WP_REPROT_OPT_60 = `${HOST}/wallpapercontent/wallpaper/report/opt`;
// 锁屏壁纸 list
export const WP_SCREEN_LIST_60 = `${HOST}/wallpapercontent/wallpaper/lock_screen_list`;

/** 6.1新增接口 */
// 为你推荐新接口
// export const SEARCH_RECOMMEND_URL = `${HOST}/appstorecontents/search/recommend`;
export const SEARCH_RECOMMEND_NEW_61 = `${HOST}/appstorecontents/recommend/recommend_new`;
// 猜你喜欢新接口
export const GUESS_LIKES_NEW_61 = `${HOST}/appstorecontents/guess/likes_new`;
// banner(支持首页和游戏 banner) 新增广告修改
export const BANNER_CONTENT_61 = `${HOST}/appstorecontents/banner/top_banner_content_v2`;
// 我的软件--分类标签list
export const UNINSTALL_CATEGORY_LIST = `${HOST}/appstorecontents/mysoft/classes`;
// 批量获取应用详情
export const UNINSTALL_MIX_BATCH_DETAILS = `${HOST}/appstorecontents/mysoft/batch_details`;

// 壁纸 获取全部作者
export const WP_AUTHOR_LIST_64 = `${HOST}/wallpapercontent/wallpaper/author_list`;
// 壁纸 获取作者详情
export const WP_AUTHOR_DETAIL_64 = `${HOST}/wallpapercontent/wallpaper/author/details`;
// 壁纸 获取作家作品集
export const WP_AUTHOR_SHOWREEL_64 = `${HOST}/wallpapercontent/wallpaper/author/showreel`;

export const SPECIALLIST_TAGS_64 = `${HOST}/appstorecontents/zt/classify_tag`;
export const SPECIALLIST_LIST_64 = `${HOST}/appstorecontents/zt/classify_tag_list`;
// 搜索结果 新增广告位6.4版本
export const SEARCH_URL_64 = `${HOST}/searchcontent/search/v2.0/search_apps`;

// v6.5 新用户引导页标签及软件推荐
export const WELCOME_DATA_65 = `${HOST}/appstorecontents/guide/contents`;
// v6.5 搜索反馈
export const FEEDBACK_SUGGEST_65 = `${HOST}/searchcontent/search/search_feedback`;
// v6.5 壁纸分类标签
export const WP_CATEGORY_LABELS_65 = `${HOST}/wallpapercontent/wallpaper/classes`;
export const WP_CATEGORY_TAGIMG_65 = `${HOST}/wallpapercontent/wallpaper/class_wallpaper_list`;
// 壁纸banner 6.5
export const WP_RECO_BANNER_65 = `${HOST}/wallpapercontent/wallpaper/banner/top_banner_content_v2`;
// 壁纸推荐group 6.5
export const WP_RECO_GROUP_65 = `${HOST}/wallpapercontent/wallpaper/group_content`;
// 壁纸推荐rank_more 6.5
export const WP_RANK_MORE_65 = `${HOST}/wallpapercontent/wallpaper/rank_more`;
// 壁纸详情页推荐的banner
export const WP_DETAIL_RECO_65 = `${HOST}​/wallpapercontent/wallpaper/banner/recommend`;

// 首页改版  banner  6.6
export const RECO_TOP_CONTENTS_66 = `${HOST}/appstorecontents/page/top_contents`;
// 首页改版  card list  6.6
export const RECO_RECOMMEND_CONTENTS_66 = `${HOST}/appstorecontents/page/op_recommend_contents`;

// 用户反馈
export const FEEDBACK_QUESTION_TYPES_66 = `${HOST}/appstorecontents/feedback/feedback_type`;
export const FEEDBACK_HOT_66 = `${HOST}/appstorecontents/feedback/feedback_hint`;
export const FEEDBACK_HOT_DELETE_66 = `${HOST}/appstorecontents/feedback/feedback_hint_remove`;
export const FEEDBACK_RECORDS_66 = `${HOST}/appstorecontents/feedback/feedback_record`;
// export const FEEDBACK_RECORDS_66 = `http://10.109.17.133:8280/feedback/feedback_record`;

// 联想词接口
export const ASSOCIATIVE_WORD_66 = `${HOST}/searchcontent/search/v2.0/associative_word`;

// v7.0
// 软件详情接口
export const APP_DETAILS_70 = `${HOST}/appstorecontents/app/details_new`;
// 安卓软件详情接口
export const APP_ADETAILS_70 = `${HOST}/appstorecontents/an_app/details_new`;
// 根据包名查询礼包列表
export const APP_DETAILS_GIFT_70 = `${HOST}/appstorecontents/gift_bag/appgift`;
// 根据包名查询礼包列表
export const APP_DETAILS_GIFT_RECEIVE_70 = `${HOST}/appstorecontents/gift_bag/receive`;

// 专题预览
export const ZT_VIEW_PAGE_70 = `${HOST}/appstorecontents/zt/preview_content`;
// 用户给商店打分
export const USER_SCORE_FORSTORE_70 = `${HOST}/appstorecontents/satisfaction/degree`;
// 专题点赞
export const SPECIAL_ZAN_70 = `${HOST}/appstorecontents/zt/report/opt`;
// 根据视屏id获取视频的内容
export const VIDEO_CONTENT_70 = `${HOST}/dlservice/video/content`;

// v7.1 教育频道
export const EDUCATION_RECOMMEND_BANNER = `${HOST}/pceducontent/page/top_contents`;
export const EDUCATION_RECOMMEND_GROUPS = `${HOST}/pceducontent/page/op_recommend_contents`;

export const EDUCATION_CATEGORY_TAGS = `${HOST}/pceducontent/category/getCategoryData`;
export const EDUCATION_CATEGORY_GRADELIST = `${HOST}/pceducontent/category/getCourserList`;

export const EDUCATION_MINE_COLLECTLIST = `${HOST}/pceducontent/my/getMyCollectList`;
export const EDUCATION_MINE_COURSELIST = `${HOST}/pceducontent/my/getMyCourserList`;
export const EDUCATION_MINE_COLLECT_DELETE = `${HOST}/pceducontent/my/deleteMyCollects`;
export const EDUCATION_MINE_COURSE_DELETE = `${HOST}/pceducontent/my/deleteMyCoursers`;
// 教育详情
export const EDUCATION_DETAIL_71 = `${HOST}/pceducontent/courser/detail`;
// 教育获取视频地址
export const EDUCATION_PLAY_URL_71 = `${HOST}/pceducontent/play/getPlayUrl`;
// 教育频道视频播放上报进度
export const EDUCATION_PLAY_DATA_REPORT_71 = `${HOST}/pceducontent/report/playDataReport`;
// 课程的收藏
export const EDUCATION_COLLECT_REPORT_71 = `${HOST}/pceducontent/report/collectReport`;

// v7.2 课程的购买创建订单
export const EDUCATION_PAY_CREATE_72 = `${HOST}/pceducontent/pay/create`;
// v7.2 课程的购买支付结果查询
export const EDUCATION_PAY_QUERY_RESULT_72 = `${HOST}/pceducontent/pay/queryResult`;
// v7.2 我购买的课程
export const EDUCATION_PAY_LIST_72 = `${HOST}/pceducontent/my/getMyPayList`;

// v7.2 专题收藏
export const SPECIAL_COLLECT_72 = `${HOST}/appstorecontents/collect/set`;
// v7.2 专题收藏
export const SPECIAL_COLLECT_SET_72 = `${HOST}/appstorecontents/collect/set`;
export const SPECIAL_COLLECT_CANCEL_72 = `${HOST}/appstorecontents/collect/remove`;
export const SOFT_COLLECT_LIST_72 = `${HOST}/appstorecontents/collect/soft_collections`;
export const SPECIAL_COLLECT_LIST_72 = `${HOST}/appstorecontents/collect/zt_collections`;

// // v7.2搜索结果添加专题类型
// export const SEARCH_URL_72 = `${HOST}/searchcontent/search/v3.0/search_apps`;

// v7.2.1 论坛  主页列表
export const FORUM_LIST_72 = `${HOST}/forumcontent/forum/content_list`;
// v7.2.1 论坛  用户发表的帖子列表
export const FORUM_LIST_PUBLISH_72 = `${HOST}/forumcontent/forum/user_content_list`;
// v7.2.1 论坛  用户收藏的帖子列表
export const FORUM_LIST_COLLECT_72 = `${HOST}/forumcontent/forum/collection_list`;
// v7.2.1 论坛  取消 点赞/收藏帖子
export const FORUM_ACTION_REMOVE_72 = `${HOST}/forumcontent/forum/action_remove`;
// v7.2.1 论坛  点赞/收藏帖子
export const FORUM_ACTION_SET_72 = `${HOST}/forumcontent/forum/action_set`;
// v7.2.1 论坛  名称查找软件列表接口
export const FORUM_ASS_WORD_72 = `${HOST}/forumcontent/forum/associative_word`;
// v7.2.1 论坛  图片上传阿里权限信息获取接口
export const FORUM_UPLOAD_PARAMS_72 = `${HOST}/forumcontent/forum/uploadParams`;
// v7.2.1 论坛  帖子详情简单信息接口
export const FORUM_INFO_72 = `${HOST}/forumcontent/forum/info`;
// v7.2.1 论坛  帖子详情信息接口
export const FORUM_CONTENT_72 = `${HOST}/forumcontent/forum/content`;
// v7.2.1 论坛  提交帖子接口
export const FORUM_SUBMIT_72 = `${HOST}/forumcontent/forum/submit`;
// v7.2.1 论坛  用户删除帖子接口
export const FORUM_DELETE_72 = `${HOST}/forumcontent/forum/delete`;
// v7.2.1 论坛  评论服务-添加评论接口
export const FORUM_COMMENT_ADD_72 = `${HOST}/comment/api/addComment_v2`;
// v7.2.1 论坛  评论服务-点赞接口
export const FORUM_COMMENT_ZAN_72 = `${HOST}/comment/api/zan_v2`;
// v7.2.1 论坛  评论服务-点赞接口
export const FORUM_COMMENT_REVIEW_72 = `${HOST}/comment/api/addreview`;
// v7.2.1 论坛  评论服务-点赞接口
export const FORUM_COMMENT_LIST_72 = `${HOST}/comment/api/commentlist_v2`;
// v7.2.1 论坛  评论-评分统计接口
export const FORUM_COMMENT_GRADE_72 = `${HOST}/comment/api/grade`;

// v7.3 分类页面获取分类信息新接口
export const CLASSES_LIST_73 = `${HOST}/appstorecontents/class/all_classes_list`;

// 7.3 分享web商店的地址
export const WEB_STORE = 'https://lestore.lenovo.com';

// v7.4 搜索框今日热搜新接口
export const HOT_SEARCH_BOX_74 = `${HOST}/pcAssociate/associate/search_box`;

// v7.4 详情页根据软件获取相关酷软圈帖子
export const APP_FORUM_RELATED_74 = `${HOST}/forumcontent/forum/app_related`;
// v7.4 消息中心小红点
export const MESSAGE_HOT_74 = `${HOST}/messagecontent/user/msg_remind`;
// v7.4 消息中心删除类别小红点
export const MESSAGE_HOT_DELETE_74 = `${HOST}/messagecontent/user/msg_remind_remove`;
// v7.4 消息中心获取各类别消息列表
export const MESSAGE_LIST_74 = `${HOST}/messagecontent/user/msg_list`;
// v7.4搜索结果添加专题类型
export const SEARCH_URL_74 = `${HOST}/searchcontent/search/v4.0/search_apps`;
